import { Plugin } from "@tiptap/pm/state";
import { Mark } from "@tiptap/pm/model";
import getMTRegex from "./getMTRegex";

export const mergeTagScannerPlugin = (syntax?: {
  start: string;
  end: string;
}) => {
  const regexSource = getMTRegex(syntax);

  return new Plugin({
    appendTransaction(transactions, oldState, newState) {
      const tr = newState.tr;
      let modified = false;

      const regex = new RegExp(regexSource, "g");
      const nodeType = newState.schema.nodes.mergeTag;

      if (!nodeType) return null;

      const replacements: { from: number; to: number; tag: string; marks: readonly Mark[] }[] = [];

      newState.doc.descendants((node, pos) => {
        if (!node.isText || !node.text) return true;

        regex.lastIndex = 0;
        const text = node.text;
        let match: RegExpExecArray | null;

        while ((match = regex.exec(text)) !== null) {
          const fullMatch = match[0];
          const start = pos + match.index;
          const end = start + fullMatch.length;

          // store the fullMatch range, but keep only clean content as tag
          replacements.push({ from: start, to: end, tag: fullMatch, marks: node.marks });
        }

        return true;
      });

      for (let i = replacements.length - 1; i >= 0; i--) {
        const { from, to, tag, marks } = replacements[i];
        tr.replaceWith(from, to, nodeType.create({ tag }, null, marks));
        modified = true;
      }

      return modified ? tr : null;
    },
  });
};
